import { queryActivityList, } from "@/api/activity";
import { advanceNoticeDetailAjax } from "@/api/live";
import { ActivityProductProvider, useSelectedActivity, useVerticalNavGray } from "@/pages/activity/hooks/useActivityProduct";
import { LiveInfo, PreheatInfo } from "@/pages/live/types/types";
import Track from "@/utils/track";
import { ActivityListModel, ItemType, useActivityList } from "@akc/biz-logic";
import { ActivityCardNormalV2Comp, } from "@akc/mx-taro-h5-components";
import { Toast } from "antd-mobile";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Cover from "../Cover";
import Header from "../Header";
import PreheatFooter from "../PreheatFooter";
import ProductList from "../ProductList/index";
import styles from "./index.module.scss";



interface GoodPreheatContentProps {
  liveNo: string;
  shopId?: string;
  // 点击预约
  onSubScribe?: (successCbk: () => void, liveInfo: PreheatInfo) => void;
  onGoToLive?: (liveStatus?: number) => void;
  // 点击分享按钮
  onShare?: () => void;
  onBrand?: () => void;
  onGoods?: () => void;
  onEvent?: () => void;
  onActivity?: () => void;
  onMoreGood?: () => void;
}

const  GoodPreheatContent: React.FC<GoodPreheatContentProps> = ({
  liveNo,
  shopId = "",
  onSubScribe,
  onGoToLive,
  onShare,
  onBrand,
  onGoods,
  onEvent,
  onActivity,
  onMoreGood,
}) => {
  // 预告详情
  const [preheatInfo, setPreheatInfo] = useState<PreheatInfo>({});
  const [activityList, setActivityList] = useState<ActivityListModel[]>([]);

  //   const {
  //     data: activityList,  // 档期列表
  //     // hasNext,
  //     // onLoadMore,
  //   } = useActivityList({
  //     pageId: "H5_ScheduleList",
  //     categoryId: "10",//商品一级类目id，10表示全部，但是这个参数跟allowActivityIds冲突，所以这里不能传
  //     activityStatus: 2,//是否预告 1: 预告 2: 直播  null:全部
  //     sortModel: 1,//排序类型：1:默认 2:上新占比 3:销量 4:转发量 5: 红包余额 6:上新次数 7:销售价 8:省赚 9:折扣 10：开始时间 11:相关度 14:销售价沉底
  //     sortType: 2,//顺序方式（排序顺序：1：ASC; 2:DESC,默认DESC）
  //     isLarge: false, // 是否大卡，首页传的false，这里也传false
  //     scene: "INDEX",//业务场景码(聚合定义)。字典表：http://wiki.aikucun.xyz/pages/viewpage.action?pageId=25659480,但目前没有直播预告场景，后端确认这里取首页场景INDEX
  //     // allowActivityIds:["1935880732785053697"],//需要查询的指定活动id
  //     pageSize:20,//待定，如果要支持分页，就用useActivityList钩子，如果是写死只查1页，则直接自行调接口，参考的queryActivityList
  //   });
  // console.log(activityList);


  /**
   * 查询直播预告详情
   * @param isAppoint 是否是预约开播提醒后的刷新
   */
  const  getAdvanceNoticeDetail = async (isAppoint = false) => {
    try {
      const rsp:any = await advanceNoticeDetailAjax({ liveNo });
      if (!rsp) {
        throw new Error("查询直播预告详情为空");
      }
      setPreheatInfo(rsp);
      if (isAppoint && rsp.isAppointment) {
        Toast.show("您已订阅开播提醒");
      }
    } catch (err: any) {
      console.error(err);
      if (err && err.message) {
        Toast.show(err.message);
      }
    }
  };


  /**
   * 查询档期列表，支持自动加载多页（最多5页）
   */
  const getActivityList = useCallback(async (activityIds) => {
    if(!activityIds || activityIds.length === 0){
      return;
    }
    
    // 定义最大页数和当前页数
    const maxPageNum = 5;
    let currentPageNum = 1;
    let hasNext = true;
    // eslint-disable-next-line no-underscore-dangle
    let _activityList:ActivityListModel[] = [];
    
    try {
      // 使用 while 循环，确保按顺序调用接口，页码依次递增
      while (currentPageNum <= maxPageNum && hasNext) {
        // 调用接口，使用当前页码
        const res = await queryActivityList({
          searchParams: {
            activityStatus: 2, //是否预告 1: 预告 2: 直播  null:全部
            // categoryId: "10",//商品一级类目id，10表示全部，但是这个参数跟allowActivityIds冲突，所以这里不能传
            isNeedSpuIds: true,
            pageNum: currentPageNum, // 使用当前页码
            pageSize: 10,
            scene: "INDEX", //业务场景码(聚合定义)。字典表：http://wiki.aikucun.xyz/pages/viewpage.action?pageId=25659480,但目前没有直播预告场景，后端确认这里取首页场景INDEX
            sortModel: 1, //排序类型：1:默认 2:上新占比 3:销量 4:转发量 5: 红包余额 6:上新次数 7:销售价 8:省赚 9:折扣 10：开始时间 11:相关度 14:销售价沉底
            sortType: 2, //顺序方式（排序顺序：1：ASC; 2:DESC,默认DESC）
            allowActivityIds: activityIds,
          },
          voConfig: {
            showType: 2, //1：大卡(不带商品)、2：小卡(带商品) 默认小卡
            withCardInsert: true,
            withProductCnt: 3, //查询对应的商品个数
            withProductCount: 3,
          },
          pageId: "H5_ScheduleList",
          storeIdsClick: "",
        });

        // 检查是否有下一页
        hasNext = res?.hasNext || false;

        // 处理当前页数据
        const onePageActivityList = (res?.result || []).map(item => {
          return {
            ...item,
            type: ItemType.ActivityCard,
            data: item,
          };
        });

        // 追加到现有列表
        _activityList.push(...onePageActivityList);

        // 当前页处理完成，页码加1
        currentPageNum++;

        if (!hasNext) {
          console.log("没有更多数据，结束循环");
        }
      }
    } catch (error) {
      console.error("获取活动列表失败:", error);
    }
    
    setActivityList(_activityList);
  }, []);

  
  
  useEffect(() => {
    // 初始查询档期列表
    const activityIds=preheatInfo?.activityList?.map(item => item.activityId);
    getActivityList(activityIds);
  }, [preheatInfo?.activityList,getActivityList]);

  // 初始化直播详情、档期列表、商品列表
  useEffect(() => {
    window.$live?.ready(() => {
      getAdvanceNoticeDetail();
    });

  //   track.track("aa-preheat", {
  //     page_name: "直播预告",
  //     live_no: liveNo,
  //     live_status: "直播预告",
  // });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 
  /**
   * 点击订阅按钮
   */
  const onSubScribeFunc = () => {
    if (onSubScribe) {
      const successCbk=() => {
        getAdvanceNoticeDetail(true);
      };
      onSubScribe(successCbk,preheatInfo);
    }
  };


  return (
    <div className={styles.good_preheat_content_wrap}>
      {/* 顶部背景图或视频 */}
      <Cover preheatInfo={preheatInfo} />

      {/* 直播间信息及转发按钮 */}
      <div className={styles.header}>
        <Header preheatInfo={preheatInfo} onShare={onShare} />
      </div>

      <div className={styles.brandTitleWrap}>
        <img
          className={styles.brandTitleIcon}
          src="https://akim-oss.aikucun.com/2326f2aff891d8ba0c119339152bfc98b9b65c52_1750514050674_45.png"
          alt=""
        />
        <p className={styles.brandTitle}>本场直播品牌及商品预告</p>
      </div>
      {/* 档期列表,钩子会在列表中加入其他资源位卡片，这里只筛选展示档期 */}
      <div className={styles.waterfallContainer}>
        {activityList
          ?.filter(item => item.type === ItemType.ActivityCard)
          .map(item => {
            return (
              <div className={styles.activity_card_wrap} key={item.activityId}>
                <ActivityCardNormalV2Comp
                  model={item.data}
                  // trackData={{
                  //   domain: "直播预告",
                  // }}
                  mainLocationCode="H5_ScheduleList_BrandDown"
                  productTLLocationCode="H5_ScheduleList_TopProductPicLeft"
                  productTRLocationCode="H5_ScheduleList_TopProductPicRight"
                />
              </div>
            );
          })}
      </div>

      {/* 商品列表 */}
      {preheatInfo?.activitySpuIdList && preheatInfo.activitySpuIdList.length > 0 && (
        <div className={styles.preheatProductListWrap}>
          <ProductList
            activityIdList={preheatInfo.activityList?.map(item => item.activityId)}
            activitySpuIdList={preheatInfo.activitySpuIdList}
          />
        </div>
      )}

      {/* 底部留白 */}
      <div
        className={styles.endWrap}
        style={{ marginBottom: preheatInfo.couponType === 1 ? "120px" : "80px" }}></div>

      {preheatInfo.planBeginTime && (
        <PreheatFooter
          planBeginTime={preheatInfo.planBeginTime}
          liveStatus={preheatInfo.liveStatus}
          isAppointment={preheatInfo.isAppointment}
          couponType={preheatInfo.couponType}
          onSubScribe={onSubScribeFunc}
          onGoToLive={onGoToLive}
        />
      )}
    </div>
  );
};

export default  GoodPreheatContent;
